import styled from "styled-components";

const Strong = styled.strong`
  font-weight: 700;
  text-transform: ${({ upper }) => (upper ? "uppercase" : "inherit")};
`;

export default Strong;



// WEBPACK FOOTER //
// ./src/components/Strong.js